module.exports = __webpack_public_path__ + "img/culture@2x.4b8b9dca.png";